import { Coord } from "../types/Interface";

export function generateAnglePoints(pointArr: Coord[]) {
  return pointArr.map((p, pI) => {
    const prevP = pointArr[pI == 0 ? pointArr.length - 1 : pI - 1];
    const nextP = pointArr[pI == pointArr.length - 1 ? 0 : pI + 1];
    return {
      curr: p,
      prev: prevP,
      next: nextP
    }
  })
}